import { $ } from "@/plug/Axios";

export default {
  /**
   * bi部门
   */
  biDepartment: {
    /*
     * 添加
     * businessFlag 是否业务部门 (string query )
     * id  (integer query )
     * levelFour 四级部门 (string query )
     * levelOne 一级部门 (string query )
     * levelThree 三级部门 (string query )
     * levelTwo 二级部门 (string query )
     * statsDepartment 统计部门 (string query )
     */
    post: (p, c) => $.post("/api/bms/statistics/biDepartment", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/biDepartment", p, c)
  },
  biDepartment_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/statistics/biDepartment/export", p, c)
  },
  biDepartment_exportSystemDepartment: {
    /*
     * 导出对应系统部门列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/biDepartment/exportSystemDepartment", p, c)
  },
  biDepartment_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/biDepartment/list", p, c)
  },
  biDepartment_listDepartmentId: {
    /*
     * 根据bi部门id获取已配置的部门id
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/biDepartment/listDepartmentId", p, c)
  },
  biDepartment_listLevelFour: {
    /*
     * 四级部门列表
     * levelOne 一级部门 (string query required)
     * levelThree 三级部门 (string query required)
     * levelTwo 二级部门 (string query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/biDepartment/listLevelFour", p, c)
  },
  biDepartment_listLevelFourSimple: {
    /*
     * 四级部门列表(带id)
     * levelOne 一级部门 (string query required)
     * levelThree 三级部门 (string query required)
     * levelTwo 二级部门 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/biDepartment/listLevelFourSimple", p, c)
  },
  biDepartment_listLevelOne: {
    /*
     * 一级部门列表
     */
    get: (p, c) => $.get("/api/bms/statistics/biDepartment/listLevelOne", p, c)
  },
  biDepartment_listLevelThree: {
    /*
     * 三级部门列表
     * levelOne 一级部门 (string query required)
     * levelTwo 二级部门 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/biDepartment/listLevelThree", p, c)
  },
  biDepartment_listLevelTwo: {
    /*
     * 二级部门列表
     * levelOne 一级部门 (string query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/biDepartment/listLevelTwo", p, c)
  },
  biDepartment_listStatsDepartment: {
    /*
     * listStatsDepartment
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/biDepartment/listStatsDepartment", p, c)
  },
  biDepartment_updateDepartmentId: {
    /*
     * 更新bi部门对应系统部门
     * departmentIds 系统部门id (array query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/biDepartment/updateDepartmentId", p, c)
  },
  biDepartment_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/statistics/biDepartment/upload", p, c)
  },
  biDepartment_uploadSystemDepartment: {
    /*
     * 导入对应系统部门列表
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/biDepartment/uploadSystemDepartment", p, c)
  },

  /**
   * bi页面
   */
  biPage: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * id  (integer query )
     * maintenanceId 维护者id (integer query )
     * name 名称 (string query )
     * thumb 缩略图 (string query )
     * url bi页面地址 (string query )
     */
    post: (p, c) => $.post("/api/bms/statistics/biPage", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/biPage", p, c)
  },
  biPage_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/biPage/list", p, c)
  },
  biPage_listAdminIds: {
    /*
     * 可查看负责人列表
     * pageId 页面id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/biPage/listAdminIds", p, c)
  },
  biPage_listPageForAdmin: {
    /*
     * 负责人可查看BI页面列表
     * name 页面名字 (string query )
     */
    get: (p, c) => $.get("/api/bms/statistics/biPage/listPageForAdmin", p, c)
  },
  biPage_updateAdmin: {
    /*
     * 编辑可查看管理员
     * adminIds 管理员id (array query required)
     * pageId 页面id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/statistics/biPage/updateAdmin", p, c)
  },
  biPage_updateSort: {
    /*
     * 编辑排序
     * sortText 排序json (string query required)
     */
    put: (p, c) => $.put("/api/bms/statistics/biPage/updateSort", p, c)
  },

  /**
   * 播报海报
   */
  broadcast_broadcastAwardInfo: {
    /*
     * 测试播报抽奖
     * adminId adminId (integer query required)
     * amount 金额 (number query required)
     * token token (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/broadcast/broadcastAwardInfo", p, c)
  },
  broadcast_test: {
    /*
     * 添加
     */
    post: (p, c) => $.post("/api/bms/statistics/broadcast/test", p, c)
  },

  /**
   * 播报配置
   */
  broadcastConfig: {
    /*
     * 添加
     * businessDepartmentIds 仅播报的事业部 (string query )
     * category 分类:合同或线索 (string query )
     * fontColor 个人播报字体颜色 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * personalAvatarFrame 个人播报头像框 (string query )
     * personalPoster 个人播报海报 (string query )
     * personalPosterHash 个人播报海报文件hash值 (string query )
     * personalPosterId 个人播报海报资源ID (integer query )
     * personalPosterTitle 个人海报标题 (string query )
     * personalText 个人播报文本 (string query )
     * personalType 个人播报类型：部门、学校 (string query )
     * robotToken 机器人token (string query )
     * siteType 学校类型 (string query )
     * timingPoster 定时播报海报 (string query )
     * timingPosterHash 定时播报海报文件hash值 (string query )
     * timingPosterId 定时播报海报资源ID (integer query )
     * timingType 定时播报类型：部门、学校 (string query )
     */
    post: (p, c) => $.post("/api/bms/statistics/broadcastConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/broadcastConfig", p, c)
  },
  broadcastConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/broadcastConfig/list", p, c)
  },

  /**
   * 线索上报统计
   */
  clueActivate_init: {
    /*
     * 定时任务,临时测试
     * endTime 结束时间 (string query )
     * startTime 开始时间 (string query )
     */
    post: (p, c) => $.post("/api/bms/statistics/clueActivate/init", p, c)
  },
  clueActivate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/clueActivate/list", p, c)
  },

  /**
   * 继教院业绩首页
   */
  continue_exportContinueStudent: {
    /*
     * 导出继教院学生列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/exportContinueStudent", p, c)
  },
  continue_exportFollowStudentForContinue: {
    /*
     * 导出继教院续读学生列表
     * adultBatch 成教批次 (string query )
     * batch 批次 (string query required)
     * level 层次 (string query )
     * site 学校 (string query )
     * type 类型：报名量、报道量、未报学历量、报成教学历量、报自考学历量、同时报名量 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/exportFollowStudentForContinue", p, c)
  },
  continue_listAdultFollowDetailForContinue: {
    /*
     * 继教院成教续读情况
     * batch 批次 (string query required)
     * level 层次 (string query )
     * site 学校 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listAdultFollowDetailForContinue",
        p,
        c
      )
  },
  continue_listContinueHeaderTeacherServiceInfo: {
    /*
     * 继教院服务-班主任带班情况
     * siteId 学校 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listContinueHeaderTeacherServiceInfo",
        p,
        c
      )
  },
  continue_listContinueLineChartData: {
    /*
     * 继教院业绩-折线图
     * batch 批次 (string query )
     * end 结束时间 (string query )
     * sources 来源详情：线上、老带新、新带新、电销、院校直招、同行 (array query )
     * start 开始时间 (string query )
     * type 类型：全部、1月、2月。。。 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listContinueLineChartData", p, c)
  },
  continue_listContinueLineChartDataForService: {
    /*
     * 继教院服务-折线图
     * batch 批次 (string query )
     * end 结束时间 (string query )
     * source 来源详情：线上，线下，同行，非同行，全部 (string query )
     * start 开始时间 (string query )
     * type 类型：全部、1月、2月。。。 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listContinueLineChartDataForService",
        p,
        c
      )
  },
  continue_listContinueSiteAdmissionsRanking: {
    /*
     * 继教院业绩-学校招生数据饼图
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listContinueSiteAdmissionsRanking",
        p,
        c
      )
  },
  continue_listContinueSiteServiceData: {
    /*
     * 继教院服务-学校服务数据饼图
     * batch 批次 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listContinueSiteServiceData", p, c)
  },
  continue_listContinueStudent: {
    /*
     * 继教院学生列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listContinueStudent", p, c)
  },
  continue_listContinueTeacherEnrollData: {
    /*
     * 继教院业绩-学校招生数据(个人排行)
     * end 结束时间 (string query )
     * siteId 院校 (integer query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listContinueTeacherEnrollData", p, c)
  },
  continue_listFollowDetailForContinue: {
    /*
     * 继教院续读情况
     * batch 批次 (string query required)
     * level 层次 (string query )
     * site 学校 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listFollowDetailForContinue", p, c)
  },
  continue_listFollowForContinue: {
    /*
     * 继教院续读情况
     * batch 批次 (string query )
     * level 层次 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listFollowForContinue", p, c)
  },
  continue_listStatsContinueSiteEnrollData: {
    /*
     * 继教院业绩-学校招生数据
     * batch 批次 (string query )
     * end 结束时间 (string query )
     * level 层次 (string query )
     * source 渠道（线上、线下、同行、非同行 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listStatsContinueSiteEnrollData",
        p,
        c
      )
  },
  continue_listStatsContinueSiteServiceData: {
    /*
     * 继教院服务-学校服务数据
     * batch 批次 (string query )
     * source 渠道（线上、线下、同行、非同行 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listStatsContinueSiteServiceData",
        p,
        c
      )
  },
  continue_reportContinuePerformance: {
    /*
     * 继教院业绩汇报
     * endTime 结束时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/reportContinuePerformance", p, c)
  },
  continue_reportContinueReportInfo: {
    /*
     * 继教院报道情况汇报
     * batch 批次 (string query )
     * end 结束时间 (string query required)
     * siteId 学校id (integer query )
     * start 开始时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/reportContinueReportInfo", p, c)
  },
  continue_statisticsForContinueEnrollByDay: {
    /*
     * 继教院汇报数据（按天）
     * classificationId 分类id (integer query )
     * timeStr 时间类型：当日、昨日、本周、上周 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/statisticsForContinueEnrollByDay",
        p,
        c
      )
  },
  continue_statisticsForContinueEnrollByMonth: {
    /*
     * 继教院汇报数据（按月）
     * classificationId 分类id (integer query )
     * startTime 传每月1号时分秒 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/statisticsForContinueEnrollByMonth",
        p,
        c
      )
  },
  continue_statisticsForContinueEnrollRank: {
    /*
     * 继教院汇报数据（排行）
     * classificationId 分类id (integer query )
     * startTime 传每月1号时分秒 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/statisticsForContinueEnrollRank",
        p,
        c
      )
  },
  continue_statisticsForContinueSchooling: {
    /*
     * 继教院每月在读情况
     * classificationId 分类id (integer query required)
     * month 月份 (integer query )
     * year 年份 (integer query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/statisticsForContinueSchooling", p, c)
  },
  continue_statisticsForContinueSchoolingExport: {
    /*
     * 继教院每月在读情况, 点击数字导出
     * id 列表返回的ID (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/statisticsForContinueSchoolingExport",
        p,
        c
      )
  },
  continue_updateReportBatch: {
    /*
     * 汇报批次更新
     * key key:继教院汇报数据春季批次、继教院汇报数据秋季批次 (string query required)
     * value value (string query required)
     */
    put: (p, c) => $.put("/api/bms/statistics/continue/updateReportBatch", p, c)
  },

  /**
   * 数据缓存
   */
  dataCache_getUpdateTime: {
    /*
     * 获取最近刷新的时间
     * requestParams 参数(协商好顺序，用逗号隔开，列表是|分割) (string query )
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/dataCache/getUpdateTime", p, c)
  },
  dataCache_getUpdateTimeForAdultEnroll: {
    /*
     * 获取最近刷新的时间-成教招生数据
     * batch 批次 (string query )
     * liveStatus 流失状态 (string query )
     * peer 是否同行 (string query )
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * timeType 时间类型 (string query )
     * type 类型：学校维度|层次维度 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataCache/getUpdateTimeForAdultEnroll", p, c)
  },
  dataCache_getUpdateTimeWithAdmin: {
    /*
     * 获取最近刷新的时间-目前仅针对listMainInfoForService方法刷新缓存
     * requestParams 参数(协商好顺序，用逗号隔开，列表是|分割) (string query )
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataCache/getUpdateTimeWithAdmin", p, c)
  },
  dataCache_getUpdateTimeWithTimeType: {
    /*
     * 获取最近刷新的时间
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * start 开始时间 (string query )
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataCache/getUpdateTimeWithTimeType", p, c)
  },
  dataCache_refresh: {
    /*
     * 刷新缓存
     * requestParams 参数(协商好顺序，用逗号隔开，列表是|分割) (string query )
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     */
    put: (p, c) => $.put("/api/bms/statistics/dataCache/refresh", p, c)
  },
  dataCache_refreshAuditEnrollData: {
    /*
     * 测试刷新缓存-成教招生数据
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshAuditEnrollData", p, c)
  },
  dataCache_refreshContinueData: {
    /*
     * 测试刷新缓存-继教院业绩汇报
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshContinueData", p, c)
  },
  dataCache_refreshForAdultEnroll: {
    /*
     * 刷新缓存,成教招生数据
     * batch 批次 (string query )
     * liveStatus 流失状态 (string query )
     * peer 是否同行 (string query )
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * timeType 时间类型 (string query )
     * type 类型：学校维度|层次维度 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshForAdultEnroll", p, c)
  },
  dataCache_refreshMainServiceData: {
    /*
     * 测试刷新缓存-数据情况缓存
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshMainServiceData", p, c)
  },
  dataCache_refreshWithAdmin: {
    /*
     * 刷新缓存-针对每个人查看的数据范围不同
     * requestParams 参数(协商好顺序，用逗号隔开，列表是|分割) (string query )
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     */
    put: (p, c) => $.put("/api/bms/statistics/dataCache/refreshWithAdmin", p, c)
  },
  dataCache_refreshWithTimeType: {
    /*
     * 刷新缓存,参数仅为时间类型
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * start 开始时间 (string query )
     * timeType 时间类型 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshWithTimeType", p, c)
  },

  /**
   * DataEase接口
   */
  dataEase_listEnrollMonthTargetFinishInfoByProduct: {
    /*
     * 根据产品获取月度目标完成情况
     * product 产品：成教、自考、继教院 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataEase/listEnrollMonthTargetFinishInfoByProduct",
        p,
        c
      )
  },
  dataEase_listEnrollWeekTargetFinishInfoByProduct: {
    /*
     * 根据产品获取周度目标完成情况
     * product 产品：成教、自考、继教院 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataEase/listEnrollWeekTargetFinishInfoByProduct",
        p,
        c
      )
  },
  dataEase_listEnrollYearTargetFinishInfoByProduct: {
    /*
     * 根据产品获取年度目标完成情况
     * product 产品：成教、自考、继教院加年份，逗号隔开 成教,2024 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataEase/listEnrollYearTargetFinishInfoByProduct",
        p,
        c
      )
  },
  dataEase_listHumanEffectiveness: {
    /*
     * 月(季)度人效
     * timeType 类型：月度、季度 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/listHumanEffectiveness", p, c)
  },

  /**
   * 部门招生目标
   */
  departmentEnrollTarget: {
    /*
     * 添加
     * bigDepartmentId 大部门id (integer query )
     * clueTarget 线索目标 (integer query )
     * countTarget 单量目标 (integer query )
     * departmentId 部门id (integer query )
     * endTime 结束时间 (string query )
     * firstOldCashFlowTarget 首次催费现金流目标 (number query )
     * gmvTarget gmv目标 (number query )
     * id  (integer query )
     * month 月 (string query )
     * newCashFlowTarget 新生现金流目标 (number query )
     * otherOldCashFlowTarget 后续催费现金流目标 (number query )
     * showParent 是否展示上级部门 (string query )
     * siteTypes 学校类型 (string query )
     * startTime 开始时间 (string query )
     * year 年 (string query )
     */
    post: (p, c) => $.post("/api/bms/statistics/departmentEnrollTarget", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/statistics/departmentEnrollTarget", p, c)
  },
  departmentEnrollTarget_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/departmentEnrollTarget/export", p, c)
  },
  departmentEnrollTarget_finishDataBySiteTypes: {
    /*
     * 根据学校类型获取统计数据
     * month 月 (string query required)
     * siteTypes 学校类型 (string query required)
     * year 年 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/departmentEnrollTarget/finishDataBySiteTypes",
        p,
        c
      )
  },
  departmentEnrollTarget_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/departmentEnrollTarget/list", p, c)
  },
  departmentEnrollTarget_listSiteTypes: {
    /*
     * 学校类型列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/departmentEnrollTarget/listSiteTypes", p, c)
  },
  departmentEnrollTarget_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/departmentEnrollTarget/upload", p, c)
  },

  /**
   * 员工归档
   */
  employeeFiling: {
    /*
     * 添加
     * adminId 员工id (integer query )
     * biDepartmentId bi部门id (integer query )
     * id  (integer query )
     * month 月份 (string query )
     * quarter 季度 (string query )
     * year 年 (string query )
     */
    post: (p, c) => $.post("/api/bms/statistics/employeeFiling", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/employeeFiling", p, c)
  },
  employeeFiling_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/statistics/employeeFiling/export", p, c)
  },
  employeeFiling_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/employeeFiling/list", p, c)
  },
  employeeFiling_listMonth: {
    /*
     * 月列表
     */
    get: (p, c) => $.get("/api/bms/statistics/employeeFiling/listMonth", p, c)
  },
  employeeFiling_listQuarter: {
    /*
     * 季度列表
     */
    get: (p, c) => $.get("/api/bms/statistics/employeeFiling/listQuarter", p, c)
  },
  employeeFiling_listYear: {
    /*
     * 年列表
     */
    get: (p, c) => $.get("/api/bms/statistics/employeeFiling/listYear", p, c)
  },
  employeeFiling_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/statistics/employeeFiling/upload", p, c)
  },

  /**
   * 员工招生指标
   */
  enroll_target_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/statistics/enroll/target/export", p, c)
  },
  enroll_target_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/enroll/target/list", p, c)
  },
  enroll_target_remove: {
    /*
     * 删除
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/enroll/target/remove", p, c)
  },
  enroll_target_save: {
    /*
     * 添加编辑
     * adminId 员工ID (integer query required)
     * assessFlag 是否纳入人效 (string query required)
     * id ID (integer query )
     * month 年 (integer query required)
     * targetCount 年 (integer query required)
     * year 年 (integer query required)
     */
    post: (p, c) => $.post("/api/bms/statistics/enroll/target/save", p, c)
  },
  enroll_target_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/statistics/enroll/target/upload", p, c)
  },

  /**
   * 招生目标
   */
  enrollTarget: {
    /*
     * 编辑
     * clueTarget 线索目标 (integer query )
     * countTarget 单量目标 (integer query )
     * departmentId 部门 (integer query )
     * endTime 结束时间 (string query )
     * firstOldCashFlowTarget 首次催费现金流目标 (number query )
     * gmvTarget gmv目标 (number query )
     * id  (integer query )
     * newCashFlowTarget 新生现金流目标 (number query )
     * otherOldCashFlowTarget 后续催费现金流目标 (number query )
     * saleAmountTarget 销售额目标 (number query )
     * startTime 开始时间 (string query )
     * targetDepartmentId 目标部门 (integer query )
     * timeContent 月、周 (integer query )
     * timeType 月、周 (string query )
     * year 年 (string query )
     */
    put: (p, c) => $.put("/api/bms/statistics/enrollTarget", p, c)
  },
  enrollTarget_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/statistics/enrollTarget/export", p, c)
  },
  enrollTarget_exportSub: {
    /*
     * 子列表导出
     */
    get: (p, c) => $.get("/api/bms/statistics/enrollTarget/exportSub", p, c)
  },
  enrollTarget_init: {
    /*
     * 初始化目标
     * type 类型 (string query required)
     * year 年 (string query required)
     */
    post: (p, c) => $.post("/api/bms/statistics/enrollTarget/init", p, c)
  },
  enrollTarget_initSubForMonth: {
    /*
     * 初始化月子目标
     * month 月 (integer query required)
     * targetDepartmentId 目标部门 (integer query required)
     * year 年 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/enrollTarget/initSubForMonth", p, c)
  },
  enrollTarget_initSubForWeek: {
    /*
     * 初始化周子目标
     * targetDepartmentId 目标部门 (integer query required)
     * weekType 周：上周、本周、下周 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/enrollTarget/initSubForWeek", p, c)
  },
  enrollTarget_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/enrollTarget/list", p, c)
  },
  enrollTarget_listEnrollMonthTargetFinishInfoByProduct: {
    /*
     * listEnrollMonthTargetFinishInfoByProduct
     * type 成教、继教院、自考 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/statistics/enrollTarget/listEnrollMonthTargetFinishInfoByProduct",
        p,
        c
      )
  },
  enrollTarget_listEnrollYearTargetExport: {
    /*
     * listEnrollYearTargetFinishInfoByProduct, 点击数字导出
     * departmentIds departmentIds (array query required)
     * month 月 (integer query )
     * product 产品： 成教  (string query required)
     * type 类型 0点击其他部门导出 1职教事业部导出  (integer query required)
     * year 年  (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/enrollTarget/listEnrollYearTargetExport", p, c)
  },
  enrollTarget_listEnrollYearTargetFinishInfoByProduct: {
    /*
     * listEnrollYearTargetFinishInfoByProduct
     * type 成教、继教院、自考 + | + 年份 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/statistics/enrollTarget/listEnrollYearTargetFinishInfoByProduct",
        p,
        c
      )
  },
  enrollTarget_listSub: {
    /*
     * 子列表
     */
    get: (p, c) => $.get("/api/bms/statistics/enrollTarget/listSub", p, c)
  },
  enrollTarget_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/statistics/enrollTarget/upload", p, c)
  },
  enrollTarget_uploadSub: {
    /*
     * 子导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/statistics/enrollTarget/uploadSub", p, c)
  },

  /**
   * 招生目标部门
   */
  enrollTargetDepartment: {
    /*
     * 添加
     * adminId 负责人 (integer query )
     * id  (integer query )
     * name 名称 (string query )
     * sort 排序 (integer query )
     * subName 子部门名称 (string query )
     * type 类型：成教、自考、继教院、大营销中心 (string query )
     */
    post: (p, c) => $.post("/api/bms/statistics/enrollTargetDepartment", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/statistics/enrollTargetDepartment", p, c)
  },
  enrollTargetDepartment_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/enrollTargetDepartment/list", p, c)
  },
  enrollTargetDepartment_listName: {
    /*
     * 名称列表
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/enrollTargetDepartment/listName", p, c)
  },
  enrollTargetDepartment_listNameForDepartmentAdmin: {
    /*
     * 部门负责人的简易列表
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/enrollTargetDepartment/listNameForDepartmentAdmin",
        p,
        c
      )
  },
  enrollTargetDepartment_listSelectDepartmentIds: {
    /*
     * 根据统计部门id获取已选择的部门ids
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/enrollTargetDepartment/listSelectDepartmentIds",
        p,
        c
      )
  },
  enrollTargetDepartment_listType: {
    /*
     * 根据管理员获取类型
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/enrollTargetDepartment/listType", p, c)
  },
  enrollTargetDepartment_listTypeForDepartmentAdmin: {
    /*
     * 部门负责人获取类型列表
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/enrollTargetDepartment/listTypeForDepartmentAdmin",
        p,
        c
      )
  },
  enrollTargetDepartment_refreshOther: {
    /*
     * 更新其他部门
     * type 类型 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/enrollTargetDepartment/refreshOther", p, c)
  },
  enrollTargetDepartment_updateDepartmentIds: {
    /*
     * 更新所属部门id
     * departmentIds 部门id (array query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/bms/statistics/enrollTargetDepartment/updateDepartmentIds",
        p,
        c
      )
  },

  /**
   * 企业线索情况首页
   */
  enterpriseClue_listSimpleAdmin: {
    /*
     * 招生老师筛选下拉数据
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/enterpriseClue/listSimpleAdmin", p, c)
  },
  enterpriseClue_statisticsEnterpriseClueForMainPage: {
    /*
     * 整体数据
     * adminId 招生老师ID (integer query )
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/enterpriseClue/statisticsEnterpriseClueForMainPage",
        p,
        c
      )
  },

  /**
   * 上交高校统计配置
   */
  handSchoolConfig: {
    /*
     * 添加
     * feeType 缴费类型 (string query )
     * id  (integer query )
     * rollGrade 学籍年级 (string query )
     * sort 排序 (integer query )
     */
    post: (p, c) => $.post("/api/bms/statistics/handSchoolConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/handSchoolConfig", p, c)
  },
  handSchoolConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/handSchoolConfig/list", p, c)
  },
  handSchoolConfig_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/handSchoolConfig/listSimple", p, c)
  },

  /**
   * 人效目标
   */
  humanEffectivenessTarget: {
    /*
     * 添加
     * allAdmin 总人数 (integer query )
     * allIncome 总营收 (number query )
     * businessAdmin 业务人数 (integer query )
     * id  (integer query )
     * month 月份 (string query )
     * netSaleAdmin 网销人数 (integer query )
     * netSaleIncome 网销营收 (number query )
     * phoneSaleAdmin 电销人数 (integer query )
     * phoneSaleIncome 电销营收 (number query )
     * quarter 季度 (string query )
     * selfAdmin 自考人数 (integer query )
     * selfIncome 自考营收 (number query )
     * serviceAdmin 服务人数 (integer query )
     * serviceIncome 服务营收 (number query )
     * year 年 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/humanEffectivenessTarget", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/statistics/humanEffectivenessTarget", p, c)
  },
  humanEffectivenessTarget_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/humanEffectivenessTarget/export", p, c)
  },
  humanEffectivenessTarget_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/humanEffectivenessTarget/list", p, c)
  },
  humanEffectivenessTarget_listMonth: {
    /*
     * 月列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/humanEffectivenessTarget/listMonth", p, c)
  },
  humanEffectivenessTarget_listQuarter: {
    /*
     * 季度列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/humanEffectivenessTarget/listQuarter", p, c)
  },
  humanEffectivenessTarget_listYear: {
    /*
     * 年列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/humanEffectivenessTarget/listYear", p, c)
  },
  humanEffectivenessTarget_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/humanEffectivenessTarget/upload", p, c)
  },

  /**
   * 教务通知情况首页
   */
  notice_statisticsNoticeForEdu: {
    /*
     * 教务通知情况(教务看)
     * classificationId 分类id (integer query required)
     * statuses 状态 (array query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/notice/statisticsNoticeForEdu", p, c)
  },
  notice_statisticsNoticeForMainPage: {
    /*
     * 教务通知情况(领导看)
     * classificationId 分类id (integer query required)
     * statuses 状态 (array query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/notice/statisticsNoticeForMainPage", p, c)
  },

  /**
   * 同行首页统计数据
   */
  peer_listSimpleEnrollTeacherForPeer: {
    /*
     * 招生老师下拉列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/peer/listSimpleEnrollTeacherForPeer", p, c)
  },
  peer_listSimpleSiteForPeer: {
    /*
     * 学校下拉列表
     */
    get: (p, c) => $.get("/api/bms/statistics/peer/listSimpleSiteForPeer", p, c)
  },
  peer_listStatisticsForPeerByEnrollTeacher: {
    /*
     * 同行首页统计数据-招生老师维度
     * batch 批次下拉, 学历批次 (string query )
     * enrollTeacherId 同行-招生老师ID，下拉 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/peer/listStatisticsForPeerByEnrollTeacher",
        p,
        c
      )
  },
  peer_listStatisticsForPeerBySite: {
    /*
     * 同行首页统计数据-学校维度
     * batch 批次下拉, 学历批次 (string query )
     * siteId 学校ID，下拉 (integer query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/peer/listStatisticsForPeerBySite", p, c)
  },
  peer_listStatisticsForPeerSchoolStatus: {
    /*
     * 同行首页统计数据-学籍状态维度
     * batch 批次下拉, 学历批次 (string query )
     * enrollTeacherId 招生老师ID，下拉 (integer query )
     * majorId 专业ID，下拉 (integer query )
     * schoolStatus 学籍状态，下拉 (string query )
     * siteId 学校ID，下拉 (integer query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/peer/listStatisticsForPeerSchoolStatus", p, c)
  },
  peer_statisticsForPeerNotice: {
    /*
     * 同行通知首页
     * batch 批次 (string query )
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * site 学校 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     * type 通知类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/peer/statisticsForPeerNotice", p, c)
  },

  /**
   * 中军线索和业绩统计相关
   */
  promote_exportForExceptionDegreeDataBoard: {
    /*
     * 中军统计数据看板, 点击数字导出
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * siteTypes 学校类型,多选 (array query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query required)
     * type 类型:订单量|全款量|现金流|销售额 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/promote/exportForExceptionDegreeDataBoard",
        p,
        c
      )
  },
  promote_listGlobalStatsDeptEnrollData: {
    /*
     * 整体数据
     * batch 批次 (string query )
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/promote/listGlobalStatsDeptEnrollData", p, c)
  },
  promote_listLineChartData: {
    /*
     * 折线图
     * classificationId 分类id (integer query required)
     * monthOrYearSelected 类型：year或month (string query required)
     * province 省份 (string query )
     * searchType 类型：全部、1月、2月。。。 (string query )
     * siteId 学校 (integer query )
     */
    get: (p, c) => $.get("/api/bms/statistics/promote/listLineChartData", p, c)
  },
  promote_listSiteEnrollData: {
    /*
     * 学校招生数据
     * batch 批次 (string query )
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * province 省份 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) => $.get("/api/bms/statistics/promote/listSiteEnrollData", p, c)
  },
  promote_statisticsClueCreateByCodeOutpost: {
    /*
     * 中军驻点线索统计数据看板
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/promote/statisticsClueCreateByCodeOutpost",
        p,
        c
      )
  },
  promote_statisticsForClueCreateByCode: {
    /*
     * 二维码线索统计首页（退役军人事业部）
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/promote/statisticsForClueCreateByCode", p, c)
  },
  promote_statisticsForExceptionDegreeDataBoard: {
    /*
     * 中军统计数据看板
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/promote/statisticsForExceptionDegreeDataBoard",
        p,
        c
      )
  },
  promote_testClueReachBroadcast: {
    /*
     * 驻点活动线索达标创建播报
     * clueCount 数量 (integer query )
     * x x (integer query )
     * y y (integer query )
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/promote/testClueReachBroadcast", p, c)
  },

  /**
   * 统计分类
   */
  statisticsClassification: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * adminIdList 名单id (string query )
     * hasOther 是否含其他部门 (string query )
     * hasWithoutPeer 是否有不包含同行 (string query )
     * id  (integer query )
     * linkUrl 链接地址 (string query )
     * listType 名单类型：白名单，黑名单 (string query )
     * name 名称 (string query )
     * platform 平台 (string query )
     * positionList 角色名单 (string query )
     * showName 显示名称 (string query )
     * showSubName 显示子名称 (string query )
     * siteTypes 学校类型，用逗号隔开 (string query )
     * sort 排序 (integer query )
     * superAdminIdList 可以查看所有数据名单id (string query )
     * type 类型：部门业绩，自定义，链接 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/statisticsClassification", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/statistics/statisticsClassification", p, c)
  },
  statisticsClassification_adultStudentEnrollAdultForExport: {
    /*
     * 继教院报名成教首页统计, 点击数字导出
     * headerTeacherId headerTeacherId (integer query )
     * level 继教院层次 (string query required)
     * province 继教院省份 (string query )
     * siteId siteId (integer query )
     * type type 0服务学生量 1在籍学生 2预报名成考量 3待异动库量 4成考已报名 5符合报名条件 6今年不报成教 7成教合同量 (integer query required)
     * year 成考年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/adultStudentEnrollAdultForExport",
        p,
        c
      )
  },
  statisticsClassification_assessStatisticsInfo: {
    /*
     * 年度招生活动考核统计页面
     * adminId adminId (integer query )
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/assessStatisticsInfo",
        p,
        c
      )
  },
  statisticsClassification_exportUnHandFirstFollowFee: {
    /*
     * 统计部门首次催费未上交列表
     * adminId 招生老师id (integer query )
     * batch 批次 (string query required)
     * classificationId 分类id (integer query required)
     * deptId 部门id (integer query )
     * site 学校 (string query )
     * siteType 学校类型 (string query required)
     * statsDeptId 统计部门id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/exportUnHandFirstFollowFee",
        p,
        c
      )
  },
  statisticsClassification_exportUnHandFollowFee: {
    /*
     * 统计部门后续催费未上交列表导出
     * adminId 班主任id (integer query )
     * classificationId 分类id (integer query required)
     * deptId 部门id (integer query )
     * feeType 缴费类型 (string query )
     * rollGrade 学籍年级 (string query )
     * site 学校 (string query )
     * siteType 学校类型 (string query )
     * statsDeptId 统计部门id (integer query )
     * year 催费年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/exportUnHandFollowFee",
        p,
        c
      )
  },
  statisticsClassification_exportUnfinishedFirstFollowFee: {
    /*
     * 统计部门首次催费未收列表
     * adminId 招生老师id (integer query )
     * batch 批次 (string query required)
     * classificationId 分类id (integer query required)
     * deptId 部门id (integer query )
     * site 学校 (string query )
     * siteType 学校类型 (string query required)
     * statsDeptId 统计部门id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/exportUnfinishedFirstFollowFee",
        p,
        c
      )
  },
  statisticsClassification_exportUnfinishedFollowFee: {
    /*
     * 统计部门后续催费未收列表导出
     * adminId 班主任id (integer query )
     * classificationId 分类id (integer query required)
     * deptId 部门id (integer query )
     * feeType 缴费类型 (string query )
     * rollGrade 学籍年级 (string query )
     * site 学校 (string query )
     * siteType 学校类型 (string query )
     * statsDeptId 统计部门id (integer query )
     * year 催费年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/exportUnfinishedFollowFee",
        p,
        c
      )
  },
  statisticsClassification_getAdminIds: {
    /*
     * 获取名单id列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/getAdminIds", p, c)
  },
  statisticsClassification_getLeveInfo: {
    /*
     * 获得层级信息
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/getLeveInfo", p, c)
  },
  statisticsClassification_getPositions: {
    /*
     * 获取角色名单列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/getPositions", p, c)
  },
  statisticsClassification_getSuperAdminIds: {
    /*
     * 获取超级名单id
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/getSuperAdminIds",
        p,
        c
      )
  },
  statisticsClassification_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/list", p, c)
  },
  statisticsClassification_listAdultExamTestHeaderTeacher: {
    /*
     * 成教摸底考试首页统计-班主任列表
     * siteId 学校id (integer query )
     * year 成考年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listAdultExamTestHeaderTeacher",
        p,
        c
      )
  },
  statisticsClassification_listAdultExamTestStatistics: {
    /*
     * 成教摸底考试首页统计
     * classificationId 分类id (integer query required)
     * siteId 学校id (integer query )
     * year 成考年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listAdultExamTestStatistics",
        p,
        c
      )
  },
  statisticsClassification_listByAdminId: {
    /*
     * 根据登陆管理员获取可以查看的统计分类
     * platform 平台 (string query )
     * showName 显示名字 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/listByAdminId", p, c)
  },
  statisticsClassification_listClueStatusForNet: {
    /*
     * 网销部线索各个状态情况
     * clueType 线索业务类型 (string query )
     * end 结束 (string query )
     * originChannel 来源渠道 (string query )
     * start 开始 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listClueStatusForNet",
        p,
        c
      )
  },
  statisticsClassification_listContinueBatch: {
    /*
     * 继教院批次列表
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listContinueBatch",
        p,
        c
      )
  },
  statisticsClassification_listDepartmentAdmissionsRanking: {
    /*
     * 部门排行榜
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listDepartmentAdmissionsRanking",
        p,
        c
      )
  },
  statisticsClassification_listGlobalStatsDeptCashFlow: {
    /*
     * 整体统计部门现金流
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listGlobalStatsDeptCashFlow",
        p,
        c
      )
  },
  statisticsClassification_listGlobalStatsDeptEnrollData: {
    /*
     * 整体统计部门招生数据
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listGlobalStatsDeptEnrollData",
        p,
        c
      )
  },
  statisticsClassification_listHeaderTeacherGraduatePer: {
    /*
     * 成教毕业率，点毕业率弹出查看
     * batch 批次 (string query )
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     * province 省份 (string query )
     * rollGrade 学籍年级 (string query )
     * siteId 学校 (integer query )
     * siteType 学校类型 (string query )
     * source source, (integer query )
     * statuses 学籍状态 (array query required)
     * type 维度:批次|学籍年级 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listHeaderTeacherGraduatePer",
        p,
        c
      )
  },
  statisticsClassification_listIndividualAdmissionsRanking: {
    /*
     * 个人排行榜
     * classificationId 分类id (integer query required)
     * limitNum 最大显示数量 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listIndividualAdmissionsRanking",
        p,
        c
      )
  },
  statisticsClassification_listLineChartData: {
    /*
     * 折线图
     * classificationId 分类id (integer query required)
     * departmentId 部门id (integer query )
     * statsDeptId 统计部门id (integer query )
     * type 类型：全部、1月、2月。。。 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listLineChartData",
        p,
        c
      )
  },
  statisticsClassification_listLineChartDataForFirstFollowFee: {
    /*
     * 首次催费折线图
     * batch 批次 (string query required)
     * classificationId 分类id (integer query required)
     * endTime 结束时间 (string query required)
     * siteType 学校类型 (string query required)
     * startTime 开始时间 (string query required)
     * type 类型：金额、比例 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listLineChartDataForFirstFollowFee",
        p,
        c
      )
  },
  statisticsClassification_listLineChartDataForFollowFee: {
    /*
     * 后续催费折线图
     * classificationId 分类id (integer query required)
     * endTime 结束时间 (string query required)
     * feeType 催费类型 (string query )
     * rollGrade 学籍年级 (string query )
     * site 学校 (string query )
     * siteType 学校类型 (string query )
     * startTime 开始时间 (string query required)
     * type 类型：金额、比例 (string query required)
     * year 催费年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listLineChartDataForFollowFee",
        p,
        c
      )
  },
  statisticsClassification_listMainInfoForSelfTaughtService: {
    /*
     * 自考平台服务整体数据
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listMainInfoForSelfTaughtService",
        p,
        c
      )
  },
  statisticsClassification_listMainInfoForService: {
    /*
     * 学历教育首页服务整体数据-服务视角
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listMainInfoForService",
        p,
        c
      )
  },
  statisticsClassification_listMainInfoForServiceByEdu: {
    /*
     * 学历教育首页服务整体数据-教务视角(教务学生情况)
     * rollGrade 学籍年级 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listMainInfoForServiceByEdu",
        p,
        c
      )
  },
  statisticsClassification_listMainInfoForServiceByEduEnroll: {
    /*
     * 学历教育首页服务整体数据-教务视角(招办学生情况)
     * batch 批次 (string query )
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listMainInfoForServiceByEduEnroll",
        p,
        c
      )
  },
  statisticsClassification_listSelfMediaPromotionEnroll: {
    /*
     * 自考多媒体推广视图-业绩占比
     * end 结束 (string query )
     * start 开始 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSelfMediaPromotionEnroll",
        p,
        c
      )
  },
  statisticsClassification_listSelfMediaPromotionLineChartData: {
    /*
     * 自考多媒体推广视图-折线图
     * type 类型：单量、转化率、成交成本、线索成本 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSelfMediaPromotionLineChartData",
        p,
        c
      )
  },
  statisticsClassification_listSelfMediaPromotionOverview: {
    /*
     * 自考多媒体推广视图-概览
     * end 结束 (string query )
     * start 开始 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSelfMediaPromotionOverview",
        p,
        c
      )
  },
  statisticsClassification_listSelfMediaPromotionSummary: {
    /*
     * 自考多媒体推广视图-自媒体业绩汇总
     * end 结束 (string query )
     * start 开始 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSelfMediaPromotionSummary",
        p,
        c
      )
  },
  statisticsClassification_listSiteHandSchoolForEducation: {
    /*
     * 上交高校(教务)
     * handSchoolConfigId 上交高校统计配置 (integer query )
     * siteType 学校类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteHandSchoolForEducation",
        p,
        c
      )
  },
  statisticsClassification_listSiteHandSchoolForService: {
    /*
     * 上交高校(服务)
     * handSchoolConfigId 上交高校统计配置 (integer query )
     * siteType 学校类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteHandSchoolForService",
        p,
        c
      )
  },
  statisticsClassification_listSiteHeaderTeacher: {
    /*
     * 班主任带班人数
     * major 专业 (string query )
     * province 省份 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatuses 学籍状态 (array query )
     * site 学校 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteHeaderTeacher",
        p,
        c
      )
  },
  statisticsClassification_listSiteStudentForEducation: {
    /*
     * 学校各状态人数(教务)
     * businessId 事业部id (integer query )
     * end 时间类型 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatuses 学籍状态 (array query )
     * siteType 学校类型 (string query )
     * start 时间类型 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteStudentForEducation",
        p,
        c
      )
  },
  statisticsClassification_listSiteStudentForSelf: {
    /*
     * 学校各状态人数(教务)
     * dimension 维度：学校、专业 (string query required)
     * rollGrade 学籍年级 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteStudentForSelf",
        p,
        c
      )
  },
  statisticsClassification_listSiteStudentForService: {
    /*
     * 学校各状态人数(服务)
     * businessId 事业部id (integer query )
     * end 时间类型 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatuses 学籍状态 (array query )
     * siteType 学校类型 (string query )
     * start 时间类型 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteStudentForService",
        p,
        c
      )
  },
  statisticsClassification_listStatsDeptCashFlow: {
    /*
     * 统计部门现金流数据
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * statsDeptId 统计部门id (integer query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listStatsDeptCashFlow",
        p,
        c
      )
  },
  statisticsClassification_listStatsDeptEnrollData: {
    /*
     * 统计部门招生数据
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * statsDeptId 统计部门id (integer query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listStatsDeptEnrollData",
        p,
        c
      )
  },
  statisticsClassification_listStatsDeptFirstFollowFee: {
    /*
     * 统计部门首次催费数据
     * batch 批次 (string query required)
     * classificationId 分类id (integer query required)
     * site 学校 (string query )
     * siteType 学校类型 (string query required)
     * statsDeptId 统计部门id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listStatsDeptFirstFollowFee",
        p,
        c
      )
  },
  statisticsClassification_listStatsDeptFollowFee: {
    /*
     * 统计部门后续催费数据
     * classificationId 分类id (integer query required)
     * feeType 催费类型 (string query )
     * rollGrade 学籍年级 (string query )
     * site 学校 (string query )
     * siteType 学校类型 (string query )
     * statsDeptId 统计部门id (integer query )
     * year 催费年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listStatsDeptFollowFee",
        p,
        c
      )
  },
  statisticsClassification_listTeacherEnrollData: {
    /*
     * 统计部门招生数据(招生老师)
     * classificationId 分类id (integer query required)
     * departmentId 部门id (integer query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * statsDeptId 统计部门id (integer query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listTeacherEnrollData",
        p,
        c
      )
  },
  statisticsClassification_listTeacherFirstFollowFee: {
    /*
     * 统计部门首次催费数据(合同负责人)
     * batch 批次 (string query required)
     * classificationId 分类id (integer query required)
     * departmentId 部门id (integer query )
     * site 学校 (string query )
     * siteType 学校类型 (string query required)
     * statsDeptId 统计部门id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listTeacherFirstFollowFee",
        p,
        c
      )
  },
  statisticsClassification_listTeacherFollowFee: {
    /*
     * 统计部门后续催费数据(班主任)
     * classificationId 分类id (integer query required)
     * departmentId 部门id (integer query )
     * feeType 催费类型 (string query )
     * rollGrade 学籍年级 (string query )
     * site 学校 (string query )
     * siteType 学籍年级 (string query )
     * statsDeptId 统计部门id (integer query )
     * year 催费年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listTeacherFollowFee",
        p,
        c
      )
  },
  statisticsClassification_listXmtClueFee: {
    /*
     * 新媒体费用数据
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/listXmtClueFee", p, c)
  },
  statisticsClassification_listXmtGroup: {
    /*
     * 获取新媒体组别
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/listXmtGroup", p, c)
  },
  statisticsClassification_listXmtGroupEnrollData: {
    /*
     * 获取新媒体分组业绩数据
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listXmtGroupEnrollData",
        p,
        c
      )
  },
  statisticsClassification_listXmtSiteTypeEnrollData: {
    /*
     * 获取新媒体各学校类型业绩数据
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listXmtSiteTypeEnrollData",
        p,
        c
      )
  },
  statisticsClassification_mainInfoForSelfTaughtServiceForExport: {
    /*
     * 自考平台服务整体数据, 点击数字导出
     * type 1未考试 2未看课程 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/mainInfoForSelfTaughtServiceForExport",
        p,
        c
      )
  },
  statisticsClassification_mainInfoForServiceByEduEnrollForExport: {
    /*
     * 学历教育首页服务整体数据-教务视角(招办学生情况), 点击数字导出
     * batch 批次,招生数据导出传入 (string query )
     * type 0异常学生 1上月招生 2本月招生 3上月审核 4本月审核 5剩余未审核  (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/mainInfoForServiceByEduEnrollForExport",
        p,
        c
      )
  },
  statisticsClassification_mainInfoForServiceForExport: {
    /*
     * 学历教育首页服务整体数据-服务视角, 点击数字导出
     * type 1异常学生 2休学逾期 3未绑定企微 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/mainInfoForServiceForExport",
        p,
        c
      )
  },
  statisticsClassification_setXmtGroup: {
    /*
     * 设置新媒体组别
     * groups 组别 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/statisticsClassification/setXmtGroup", p, c)
  },
  statisticsClassification_statisticsAdultGraduateInfo: {
    /*
     * 成教毕业率查看视图-批次|学籍年级维度
     * batches 批次 (array query )
     * classificationId 分类id (integer query required)
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     * province 省份 (string query )
     * rollGrades 学籍年级 (array query )
     * siteType 学校类型 (string query )
     * statuses 学籍状态 (array query required)
     * type 维度:批次|学籍年级 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsAdultGraduateInfo",
        p,
        c
      )
  },
  statisticsClassification_statisticsAdultGraduateInfoExport: {
    /*
     * 成教毕业率, 点击数字导出
     * batch 批次 (string query )
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     * province 省份 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatus 学籍状态, 正常毕业|延迟毕业|异常|未毕业 (string query )
     * siteId 学校ID (integer query )
     * siteType 学校类型 (string query )
     * statuses 学籍状态, 多选, 正常的学籍状态 (array query )
     * type 维度:批次|学籍年级 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsAdultGraduateInfoExport",
        p,
        c
      )
  },
  statisticsClassification_statisticsAdultGraduateInfoExportForEdu: {
    /*
     * 成教毕业率, 点击数字导出 （教务查看，高校负责人看自己）
     * batch 批次 (string query )
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     * province 省份 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatus 学籍状态, 正常毕业|延迟毕业|异常|未毕业 (string query )
     * siteId 学校ID (integer query )
     * siteType 学校类型 (string query )
     * statuses 学籍状态, 多选, 正常的学籍状态 (array query )
     * type 维度:批次|学籍年级 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsAdultGraduateInfoExportForEdu",
        p,
        c
      )
  },
  statisticsClassification_statisticsAdultGraduateInfoForEdu: {
    /*
     * 成教毕业率查看视图-批次|学籍年级维度 （教务查看，高校负责人看自己）
     * batches 批次 (array query )
     * classificationId 分类id (integer query required)
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     * province 省份 (string query )
     * rollGrades 学籍年级 (array query )
     * siteType 学校类型 (string query )
     * statuses 学籍状态 (array query required)
     * type 维度:批次|学籍年级 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsAdultGraduateInfoForEdu",
        p,
        c
      )
  },
  statisticsClassification_statisticsContinueStudentEnrollAdult: {
    /*
     * 继教院报名成教首页统计
     * classificationId 分类id (integer query required)
     * level 继教院层次 (string query required)
     * province 继教院省份 (string query )
     * siteId 学校id (integer query )
     * year 成考年度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsContinueStudentEnrollAdult",
        p,
        c
      )
  },
  statisticsClassification_statisticsForAdultEnrollBySiteOrLevel: {
    /*
     * 成教招生数据统计（学校、层次维度）
     * batch 批次 (string query )
     * classificationId 分类id (integer query required)
     * liveStatus 流失状态 (string query )
     * peer 是否同行 (string query )
     * timeType 时间类型 (string query )
     * type 类型： 学校维度|层次维度 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForAdultEnrollBySiteOrLevel",
        p,
        c
      )
  },
  statisticsClassification_statisticsForArmyContract: {
    /*
     * 中军双拥首页动统计
     * classificationId 分类id (integer query required)
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForArmyContract",
        p,
        c
      )
  },
  statisticsClassification_statisticsForArmyContractExport: {
    /*
     * 中军双拥首页动统计, 点击数字导出
     * belong 所属类型 (string query )
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * start 开始时间 (string query )
     * street 街道 (string query )
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForArmyContractExport",
        p,
        c
      )
  },
  statisticsClassification_statisticsForContinueFinance: {
    /*
     * 职教缴费数据统计报表-财务
     * batch 批次 (string query required)
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForContinueFinance",
        p,
        c
      )
  },
  statisticsClassification_statisticsForSelfTaughtScoreInfo: {
    /*
     * 自考成绩统计整体数据
     * category 学生来源 (string query required)
     * classificationId 分类id (integer query required)
     * examBatch 考期（自考） (string query )
     * province 省份 (string query required)
     * sourceSiteIds 学校ids, 学生来源是继教院时 (array query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForSelfTaughtScoreInfo",
        p,
        c
      )
  },
  statisticsClassification_statisticsForSelfTaughtWechat: {
    /*
     * 自考企微月触达情况
     * classificationId 分类id (integer query required)
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForSelfTaughtWechat",
        p,
        c
      )
  },
  statisticsClassification_statisticsForSelfTaughtWechatExport: {
    /*
     * 自考企微月触达情况, 点击数字导出
     * departmentId 部门ID (integer query )
     * headerTeacherId 班主任ID (integer query )
     * month 月 (integer query required)
     * type 0服务学生 1无需绑定 2已绑定 3未绑定 4已触达 5未触达  (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForSelfTaughtWechatExport",
        p,
        c
      )
  },
  statisticsClassification_statisticsForServiceWechat: {
    /*
     * 服务部企微月触达情况
     * classificationId 分类id (integer query required)
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForServiceWechat",
        p,
        c
      )
  },
  statisticsClassification_statisticsForServiceWechatExport: {
    /*
     * 服务部企微月触达情况, 点击数字导出
     * departmentId 部门ID (integer query )
     * headerTeacherId 班主任ID (integer query )
     * month 月 (integer query required)
     * type 0服务学生 1无需绑定 2已绑定 3未绑定 4已触达 5未触达  (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForServiceWechatExport",
        p,
        c
      )
  },
  statisticsClassification_updateAdminIds: {
    /*
     * 人员名单编辑
     * adminIds 名单id (array query )
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/statisticsClassification/updateAdminIds", p, c)
  },
  statisticsClassification_updatePositions: {
    /*
     * 角色名单编辑
     * id id (integer query required)
     * positions 角色名单 (array query )
     */
    put: (p, c) =>
      $.put(
        "/api/bms/statistics/statisticsClassification/updatePositions",
        p,
        c
      )
  },
  statisticsClassification_updateSuperAdminIds: {
    /*
     * 超级名单编辑
     * adminIds 名单id (array query )
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/bms/statistics/statisticsClassification/updateSuperAdminIds",
        p,
        c
      )
  },

  /**
   * 统计部门
   */
  statisticsDepartment: {
    /*
     * 添加
     * adminId 负责人 (integer query )
     * backgroundColor 背景颜色 (string query )
     * classificationId 分类id (integer query )
     * departmentIds 部门id (string query )
     * icon 图标 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * shadeColor 阴影颜色 (string query )
     * sort 排序 (integer query )
     */
    post: (p, c) => $.post("/api/bms/statistics/statisticsDepartment", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/statisticsDepartment", p, c)
  },
  statisticsDepartment_getDepartmentIds: {
    /*
     * 获取部门id
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsDepartment/getDepartmentIds", p, c)
  },
  statisticsDepartment_listByClass: {
    /*
     * 列表
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsDepartment/listByClass", p, c)
  },
  statisticsDepartment_listStatsDept: {
    /*
     * 根据分类获取统计部门列表
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsDepartment/listStatsDept", p, c)
  },
  statisticsDepartment_listSysDept: {
    /*
     * 根据统计部门id获取系统部门列表
     * id 统计部门id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsDepartment/listSysDept", p, c)
  },
  statisticsDepartment_updateDepartmentId: {
    /*
     * 名单编辑
     * departmentIds 部门id (array query )
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/statisticsDepartment/updateDepartmentId", p, c)
  },

  /**
   * 统计分类
   */
  statisticsForEmployeeAppraise_statisticsEmployeeAppraiseByEveryOneMonth: {
    /*
     * 360度评测首页统计- 个人评测统计-总分
     * adminId 被评价人 (integer query )
     * classificationId 分类id (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsForEmployeeAppraise/statisticsEmployeeAppraiseByEveryOneMonth",
        p,
        c
      )
  },
  statisticsForEmployeeAppraise_statisticsEmployeeAppraiseByItem: {
    /*
     * 360度评测首页统计- 个人评测统计-平均分
     * adminId 被评价人 (integer query )
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsForEmployeeAppraise/statisticsEmployeeAppraiseByItem",
        p,
        c
      )
  },
  statisticsForEmployeeAppraise_statisticsEmployeeAppraiseForLeader: {
    /*
     * 360度评测首页统计- 领导查看
     * classificationId 分类id (integer query required)
     * itemIds 考核项列表 (array query )
     * month 月 (integer query required)
     * selectedAdminIds 被评价人列表 (array query )
     * selectedDepartmentIds 被评价人部门 (array query )
     * year 年 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsForEmployeeAppraise/statisticsEmployeeAppraiseForLeader",
        p,
        c
      )
  },

  /**
   * 统计子类
   */
  statisticsSubclass: {
    /*
     * 添加
     * classificationId 分类id (integer query )
     * id  (integer query )
     * name 名称 (string query )
     * siteTypes 学校类型，用逗号隔开 (string query )
     * sort 排序 (integer query )
     */
    post: (p, c) => $.post("/api/bms/statistics/statisticsSubclass", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/statisticsSubclass", p, c)
  },
  statisticsSubclass_listByClass: {
    /*
     * 列表
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsSubclass/listByClass", p, c)
  }
};
